import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxDataGridComponent,
  DxLoadPanelComponent,
  DxPopupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import {
  DxiDataGridItemComponent,
  DxoDataGridSelectionComponent,
  DxoDataGridToolbarComponent,
} from 'devextreme-angular/ui/data-grid';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoSelectionComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';
import { Dipendente } from 'src/app/models/dipendente';
import { Mansioni } from 'src/app/models/mansioni';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';
import { Reparti } from 'src/app/models/reparti';
import { BtnNewDipendenteComponent } from 'src/app/shared/components/dipendenti/btn-new-dipendente/btn-new-dipendente.component';
import { PopupBarCodeComponent } from 'src/app/shared/components/popups/popup-barcode/popup-barcode.component';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MansioniService } from 'src/app/shared/services/mansioni.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { RepartiService } from 'src/app/shared/services/reparti.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-dipendenti',
  templateUrl: './dipendenti.component.html',
  styleUrls: ['./dipendenti.component.scss'],
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    DxButtonComponent,
    BtnNewDipendenteComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxiColumnComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoFilterRowComponent,
    DxoSelectionComponent,
    DxoLookupComponent,
    DxoDataGridSelectionComponent,
    DxoDataGridToolbarComponent,
    DxiDataGridItemComponent,
    DxLoadPanelComponent,
    DxPopupComponent,
    PopupBarCodeComponent,
    DxoExportComponent,
    DxCheckBoxComponent
  ],
})
export class DipendentiComponent implements OnInit {
  private dipendentiS = inject(DipendentiService);
  private repartiService = inject(RepartiService);
  private mansioniService = inject(MansioniService);
  private nS = inject(NavigatorService);
  @ViewChild('grid', { static: false }) dataGrid!: DxDataGridComponent;

  dataSource: any;
  filterValue: any = true;
  listReparti: Reparti[] = [];
  listMansioni: Mansioni[] = [];
  listDipendenti: any;
  columnResizingMode = 'widget';

  visibleLoadPanel: boolean = false;

  printBarcodeModel: PrintBarCodeModel = new PrintBarCodeModel();
  popupInfoBarCode: boolean = false;
  soloAttivi: boolean = true;

  loadLookups() {
    this.repartiService.listTemp().subscribe({
      next: (res) => {
        this.listReparti = res;
      }
    });

    this.mansioniService.list().subscribe({
      next: (res) => {
        this.listMansioni = res;
      },
      error: (error) => {
        console.error('Errore caricamento mansioni: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento mansioni', 'warning');
        }
      },
    });
  }

  ngOnInit() {
    this.loadLookups();
    this.loadDataSource();
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.dipendentiS.listTemp())
          .then((response) => {
            this.listDipendenti = {
              store: {
                type: 'array',
                data: response,
                key: 'id',
              },
              pageSize: 10,
              paginate: true,
            };
            return{
                data: response,
              }
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
    });
  }

  goToDetail(e: any) {
    this.nS.goToDipendentiDetail(e.id);
  }

  goToDashboard(e:any) {
    this.nS.goToDipedenteDashboard(e.id);
  }

  dettaglioDipendente(id: number) {
    this.nS.goToDipendentiDetail(id);
  }

  getRepartoDisplayExpr(item: Reparti) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.sito?.descrizione?.length > 0
        ? ' (' + item.sito.descrizione + ')'
        : '')
    );
  }

  getMansioneDisplayExpr(item: Mansioni) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.descrizione;
  }

  getResponsabileDisplayExpr(item: Dipendente) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.nominativo;
  }

  onXlsButtonClick() {
    this.nS.goToDipendentiImport();
  }
  goToDipendenteNew() {
    this.nS.goToDipendentiNew();
  }

  stampaEtichetteDipendenti() {
    const keys = this.dataGrid.instance.getSelectedRowKeys() as number[];
    if (keys.length == 0) {
      notify(
        'Selezionare almeno un dipendente per la stampa delle etichette',
        'warning',
      );
      return;
    }
    this.printBarcodeModel.idsObject = keys;
    this.popupInfoBarCode = true;
  }

  onPopupBarcodeEventEmitter(event: any) {
    this.popupInfoBarCode = false;
    this.visibleLoadPanel = true;
    this.printBarcodeModel.grande = event.grande;
    this.printBarcodeModel.numeroCopie = event.numeroCopie;
    this.dipendentiS.stampaEtichette(this.printBarcodeModel).subscribe({
      next: (res) => {
        this.dataGrid.instance.deselectAll();
        this.visibleLoadPanel = false;
        const url = window.URL.createObjectURL(res);
        window.open(url);
      },
      error: (err) => {
        this.visibleLoadPanel = false;
        if (err?.error?.title) {
          notify(err.error.title, 'error');
        } else {
          notify('Errore stampa Etichetta', 'error');
        }
      },
    });
  }

  onExporting(e: any) {
    GridExportExcel(e, 'Dipendenti', 'Dipendenti.xlsx');
  }

  onAttiviChanged(e: any){
    this.soloAttivi = e.value;
    this.filtraGriglia();
  }

  filtraGriglia(){
    if(this.soloAttivi){
      this.dataGrid?.instance?.filter([['attivo', '=', true]]);
    }
    else{
      this.dataGrid?.instance?.clearFilter();
    }
  }

  onContentReady(e: any){
    this.filtraGriglia();
  }
}
